export enum SearchType {
  User = 'user',
  Organization = 'organization',
  Customer = 'customer',
  Device = 'device',
}

export const searchTypes = [
  SearchType.User,
  SearchType.Organization,
  SearchType.Customer,
  SearchType.Device,
];

export const searchTypeLabelKeys: Record<SearchType, string> = {
  [SearchType.User]: 'user',
  [SearchType.Organization]: 'organisation',
  [SearchType.Customer]: 'customer',
  [SearchType.Device]: 'device',
};

export const searchPlaceholderKeys: Record<SearchType, string> = {
  [SearchType.User]: 'adminSearchUserPlaceholder',
  [SearchType.Organization]: 'adminSearchOrganizationPlaceholder',
  [SearchType.Customer]: 'adminSearchCustomerPlaceholder',
  [SearchType.Device]: 'adminSearchDevicePlaceholder',
};
